module.exports = __webpack_public_path__ + "static/media/YM70_3.2ab644a5.jpg";